import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import { Styles } from './styles'
import Grid from "@material-ui/core/Grid";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { useHistory, useLocation } from 'react-router-dom';
import RedemptionAPI from 'apis/redemption/redemption';
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import Context from 'context/context';
import TableContainer from "@material-ui/core/TableContainer";


//Helpers
import {dateFormat, pointsFormat} from "helpers/dataFormat"


function RedemptionDetail() {
    const { state, dispatch } = useContext(Context)
    const classes = Styles()
    const history = useHistory()
    const location = useLocation()
    const { getRedemptionDetails } = RedemptionAPI()
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const { t , i18n}= useTranslation();

    useEffect(() => {
        handleGetRedemptionDetails()
    }, [])

    useEffect(() => {
        dispatch({
            type: "SET_PATHNAME",
            payload: ["HOME", "ADMIN", "Redemption Details"],
        });
    }, []);

    async function handleGetRedemptionDetails() {
        try {
            setLoading(true)
            let redemptionDetails = await getRedemptionDetails({ transaction_id: location?.state?.data?.transaction_id })
            if (redemptionDetails) {
                setData(redemptionDetails)
            }
            setLoading(false)
        } catch (error) {
            console.log({ error });
        }
    }

    //console.log({ data: location?.state?.data });

    const burnPointsDistributionHeading = location?.state?.data?.transaction_status.toLowerCase() == "inprogress" ? [
        "Earn Transaction Id",
        "Points Used",
        "Redemption Date",
        "Earn Transaction Date",
    ] : [
        "Earn Transaction Id",
        "Points Reversed",
        "Redemption Date",
        "Earn Transaction Date",
    ]

    const discountMappingHeading = location?.state?.data?.transaction_status.toLowerCase() == "inprogress" ? [
        "Order Number",
        "Order Line Number",
        "Order Date",
        // "Total Redeemable Points",
        // "Points Left to Redeem",
        "Points Redeemed",
    ] : [
        "Order Number",
        "Order Line Number",
        "Order Date",
        // "Total Redeemable Points",
        // "Points Left to Redeem",
        "Points Reversed",
    ]

    return (
        <>
            <Grid
                className={classes.detailsPageHeader}
            >
                <Grid
                    xs={12}
                    sm={12}
                    lg={12}
                    className={classes.detailsPageHeaderGrid}
                >
                    <ArrowBackOutlinedIcon
                        className={classes.backArrowIcon}
                        onClick={() => {
                            history.push({ pathname: '/dashboard/redemption-details', searchValue: location?.state?.search });
                        }}
                    />
                    <div className={classes.detailsPageHeaderContent}>
                        <div>{t("Qualified sales orders for Member ID")}: {location?.state?.data?.loyalty_id}</div>
                        <div>{t("Points Redeemed")}: {pointsFormat(location?.state?.data?.points_redeemed,i18n.language)}</div>
                    </div>
                </Grid>
            </Grid>
            <TableContainer className={classes.tableContainer}>
                {!loading ? <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {discountMappingHeading.map(h => <TableCell className={classes.tableHeading}>{t(h)}</TableCell>)}
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data?.discountMapping && data.discountMapping.map((n, i) => {
                            return (
                                <TableRow key={i}>
                                    <TableCell align="left">{n.order_number}</TableCell>
                                    <TableCell align="left">{n.order_line_number}</TableCell>
                                    <TableCell align="left">{dateFormat(n["Order_Line_Item.order_date"],i18n.language)}</TableCell>
                                    {/* <TableCell style={{ textAlign: 'center' }}>{n.total_redeemable_points}</TableCell> */}
                                    {/* <TableCell style={{ textAlign: 'center' }}>{n.points_left_to_redeem}</TableCell> */}
                                    <TableCell align="left">{pointsFormat(n.requested_redeemed_points,i18n.language)}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table> : <h2 className={classes.loadingText}>{t("Loading")}...</h2>}
            </TableContainer>
            <Grid
                className={classes.detailsPageHeader}
            >
                <Grid
                    xs={12}
                    sm={12}
                    lg={12}
                    className={classes.detailsPageHeaderGrid}
                >
                    <ArrowBackOutlinedIcon
                        className={classes.backArrowIcon}
                        onClick={() => {
                            history.push({ pathname: '/dashboard/redemption-details', searchValue: location?.state?.search });
                        }}
                    />
                    <div className={classes.detailsPageHeaderContent}>
                        <div>{t("Qualified sales transaction for Member ID")}: {location?.state?.data?.loyalty_id}</div>
                        <div>{t("Points Redeemed")}: {pointsFormat(location?.state?.data?.points_redeemed,i18n.language)}</div>
                    </div>
                </Grid>
            </Grid>
            <TableContainer className={classes.tableContainer}>
                {!loading ? <Table stickyHeader>
                    <TableHead>
                        <TableRow                        >
                            {burnPointsDistributionHeading.map(h => <TableCell className={classes.tableHeading}>{t(h)}</TableCell>)}
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data?.burnPointsDistribution && data.burnPointsDistribution.map((n, i) => {
                            return (
                                <TableRow key={i}>
                                    <TableCell align="left">{n.earn_transaction_id}</TableCell>
                                    <TableCell align="left">{pointsFormat(n.points_used,i18n.language)}</TableCell>
                                    <TableCell align="left">{dateFormat(n.redemption_date,i18n.language)}</TableCell>
                                    <TableCell align="left">{dateFormat(n.earn_transaction_date,i18n.language)}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table> : <h2 className={classes.loadingText}>{t("Loading")}...</h2>}
            </TableContainer>
        </>
    )
}

export default RedemptionDetail